var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPopcorn = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.954,
    height: 25.41,
    viewBox: "0 0 18.954 25.41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2190",
    "data-name": "Grupo 2190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5474",
    "data-name": "Caminho 5474",
    d: "M222.47,259.22l1.756,13.792a.548.548,0,0,0,.533.475h12.13a.532.532,0,0,0,.533-.475l1.764-13.792Z",
    transform: "translate(-221.354 -248.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5475",
    "data-name": "Caminho 5475",
    d: "M472.875,4779.065a15.616,15.616,0,0,0-.391-1.524l1.242-.989.655-.218.379-1s-.149-.955-.161-.989.207-1.081.207-1.081l.793-.506.795.117.62.09,1.15-.621.885.058.724.563.7.541a6.826,6.826,0,0,0,1.081,0c.012-.058.966-.966.966-.966l1.161-.081.874.437.678.8.333.7,1.023.333.632.6.207.7,1.092.3.874.6.218,1.024-.368,1.11-.276.959-16.1-.172A1.5,1.5,0,0,0,472.875,4779.065Z",
    transform: "translate(-471.481 -4771.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5476",
    "data-name": "Caminho 5476",
    d: "M229.011,93.6a2.288,2.288,0,0,0-2.052-1.728,2.574,2.574,0,0,0-4.528-.72,2.337,2.337,0,0,0-.554-.065c-.079,0-.158.007-.238.014a2.285,2.285,0,0,0-2-1.188,2.256,2.256,0,0,0-1.555.619,2.057,2.057,0,0,0-2.613,2.735.157.157,0,0,0,.022.036,2.626,2.626,0,0,0-.461.821,2.272,2.272,0,0,0-1.181,3.851.566.566,0,0,0,.382.158.522.522,0,0,0,.382-.158.537.537,0,0,0-.007-.763,1.176,1.176,0,0,1-.36-.849,1.194,1.194,0,0,1,1.181-1.195h.029a1.138,1.138,0,0,1,.511.122.543.543,0,0,0,.727-.245.549.549,0,0,0-.245-.727c-.094-.043-.187-.086-.288-.122a1.557,1.557,0,0,1,2.34-.41.542.542,0,0,0,.7-.828,2.632,2.632,0,0,0-.705-.425,1.214,1.214,0,0,1-.058-.36,1.195,1.195,0,0,1,2.39,0,1.183,1.183,0,0,1-.014.166.542.542,0,1,0,1.073.151,2.343,2.343,0,0,0,.022-.317v-.014a1.178,1.178,0,0,1,1.137.986.534.534,0,0,0,.533.446.443.443,0,0,0,.094-.007.54.54,0,0,0,.439-.626,2.259,2.259,0,0,0-.72-1.3,1.5,1.5,0,0,1,2.476.4,2.231,2.231,0,0,0-.842.648.537.537,0,0,0,.835.677,1.2,1.2,0,0,1,.929-.446,1.189,1.189,0,0,1,1.116.777,2.63,2.63,0,0,0-.921.554,1.541,1.541,0,0,0-1.332.454.54.54,0,0,0,.777.749.445.445,0,0,1,.77.3.542.542,0,0,0,.54.533h.007a.544.544,0,0,0,.533-.547,1.548,1.548,0,0,0-.3-.893,1.489,1.489,0,0,1,.576-.2.091.091,0,0,0,.043-.007.962.962,0,0,1,.144-.007,1.493,1.493,0,0,1,1.49,1.49,1.476,1.476,0,0,1-.54,1.145.546.546,0,0,0-.072.763.535.535,0,0,0,.418.194.562.562,0,0,0,.346-.122,2.551,2.551,0,0,0-1.368-4.506Zm-12.439-1.72a.97.97,0,0,1,.907-.4,2.249,2.249,0,0,0-.108.7,1.387,1.387,0,0,0,.007.173,2.651,2.651,0,0,0-.979.245.925.925,0,0,1,.173-.72Z",
    transform: "translate(-212.671 -89.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_2",
    "data-name": "Linha 2",
    x2: 0.736,
    y2: 10.302,
    transform: "translate(3.958 13.195)",
    fill: "none",
    stroke: "#f95e14",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_3",
    "data-name": "Linha 3",
    x2: 0.201,
    y2: 10.302,
    transform: "translate(7.637 13.195)",
    fill: "none",
    stroke: "#f95e14",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_4",
    "data-name": "Linha 4",
    x2: 0.201,
    y2: 10.302,
    transform: "translate(10.781 13.119)",
    fill: "none",
    stroke: "#f95e14",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_5",
    "data-name": "Linha 5",
    x1: 0.736,
    y2: 10.302,
    transform: "translate(13.885 13.195)",
    fill: "none",
    stroke: "#f95e14",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5477",
    "data-name": "Caminho 5477",
    d: "M223.923,203.55H206.057a.544.544,0,0,1-.54-.54v-1.764a.544.544,0,0,1,.54-.54h17.874a.544.544,0,0,1,.54.54v1.764a.545.545,0,0,1-.547.54Z",
    transform: "translate(-205.517 -193.415)",
    fill: "#f95e14"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPopcorn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/popcorn.ebc787dfa788e158.svg";